export default __webpack_public_path__ + "static/media/icon-hamburger.05a40a49.svg";